<nz-date-picker
  [nzBackdrop]="true"
  vpfaInputLabel="Reg. date"
  [nzFormat]="'short' | localeDateFormat"
  [nzSize]="size"
  (ngModelChange)="onDateSelect($event)"
  [(ngModel)]="model"
></nz-date-picker>
